module.exports = __webpack_public_path__ + "assets/safari-pinned-tab.svg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/icons/safari-pinned-tab.svg
// module id = 927
// module chunks = 17